import React from 'react';

//Import plaidLink component
import PlaidLinkClass from './PlaidLinkClass.tsx';

const plaidPage = (props) => {

    return (
        <div className="App">
            <PlaidLinkClass clientID={props.clientID} apiKey={props.apiKey} name={props.name}/>
        </div>
    );
}

export default plaidPage;